module.exports = __webpack_public_path__ + "img/16.a80016f8.png";